import {
  errnoDataSlientMiddleware,
  errnoDataMiddleware,
  errnoMiddleware,
  loadingMiddleware,
  networkErrorMiddleware,
  handleFoodPriceControlMiddleware,
  errnoSlientMiddleware,
} from './middlewares'

/**
 * 应用Promise中间件
 * @param middlewares Promise中间件
 * @returns {function(*=, ...[*]=): Promise<any>}
 */
export function applyPromiseMiddleware(middlewares = []) {
  return (method, ...params) => {
    return new Promise((resolve, reject) => {
      let response = method.apply(null, params)
      middlewares.forEach(middleware => {
        response = middleware({ method, params }, response)
      })
      response.then(resolve, reject)
    })
  }
}

// 什么都没处理
export const requestHelper = applyPromiseMiddleware([networkErrorMiddleware, errnoMiddleware])
// 返回值少了层data
export const requestDataHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  errnoDataMiddleware,
])
// 有加载loding
export const requestLoadingHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  loadingMiddleware,
  errnoMiddleware,
])
// 返回值少了层data && 有加载loding
export const requestDataLoadingHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  loadingMiddleware,
  errnoDataMiddleware,
])
// 返回值少了层data && 有加载loding && 有报错提示
export const requestDataLoadingSilentErrorHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  loadingMiddleware,
  errnoDataSlientMiddleware,
])
// 返回值 有加载loding && 有报错提示
export const requestLoadingSilentErrorHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  loadingMiddleware,
  errnoSlientMiddleware,
])
// 特制非常规
export const requestHandleFoodPriceControlLoadingHelper = applyPromiseMiddleware([
  networkErrorMiddleware,
  loadingMiddleware,
  handleFoodPriceControlMiddleware,
])
